import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["referrerId", "timelineItemType", "timelineItemId"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import { mergeWith } from "lodash";
import Vue from "vue";
export const SET_REFERRERS = "SET_REFERRERS";
export const SET_REFERRER = "SET_REFERRER";
export const SET_REFERRERS_CUSTOM_FIELDS_DEFINITIONS = "SET_REFERRERS_CUSTOM_FIELDS_DEFINITIONS";
export const SET_REFERRER_CUSTOM_FIELD_DEFINITION = "SET_REFERRER_CUSTOM_FIELD_DEFINITION";
export const SET_REFERRER_CUSTOM_FIELDS = "SET_REFERRER_CUSTOM_FIELDS";
export const SET_REFERRER_CUSTOM_FIELD_ORDER = "SET_REFERRER_CUSTOM_FIELD_ORDER";
export const EDIT_REFERRER = "EDIT_REFERRER";
export const REMOVE_REFERRER = "REMOVE_REFERRER";
export const REMOVE_REFERRER_CUSTOM_FIELD_DEFINITION = "REMOVE_REFERRER_CUSTOM_FIELD_DEFINITION";
export const ADD_REFERRER_CUSTOM_FIELD_DEFINITION = "ADD_REFERRER_CUSTOM_FIELD_DEFINITION";
export const SET_REFERRER_LINKED_APPS = "SET_REFERRER_LINKED_APPS";
export const SET_REFERRER_LINKED_PROFILES = "SET_REFERRER_LINKED_PROFILES";
export const ADD_REFERRER_TIMELINE_ITEM = "ADD_REFERRER_TIMELINE_ITEM";
export const SET_REFERRER_TIMELINE_ITEM_DETAILS = "SET_REFERRER_TIMELINE_ITEM_DETAILS";
export const REMOVE_REFERRER_TIMELINE_ITEM = "REMOVE_REFERRER_TIMELINE_ITEM";
export const SET_REFERRER_TIMELINE = "SET_REFERRER_TIMELINE";
export const SET_REFERRER_CHANGELOG = "SET_REFERRER_CHANGELOG";
export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";
export const RESET_REFERRERS = "RESET_REFERRERS";
const mutations = {
  [SET_REFERRERS]: (state, {
    referrers,
    total,
    add,
    rawReferrers
  }) => {
    if (add) {
      state.rawReferrers.push(..._mapInstanceProperty(rawReferrers).call(rawReferrers, r => _objectSpread(_objectSpread({}, r), {}, {
        fullName: r.givenName + " " + r.familyName
      })));
      state.referrers.byId = _objectSpread(_objectSpread({}, state.referrers.byId), referrers.byId);
      state.referrers.allIds.push(...referrers.allIds);
    } else {
      state.referrers = referrers;
    }
    state.totalReferrers = total;
  },
  [RESET_REFERRERS]: state => {
    state.referrers.byId = {};
    state.referrers.allIds = [];
    state.rawReferrers = [];
  },
  [SET_REFERRER]: (state, {
    referrer,
    referrerId
  }) => {
    var _state$referrers$byId, _context;
    const timeline = (_state$referrers$byId = state.referrers.byId[referrerId]) == null ? void 0 : _state$referrers$byId.timeline;
    Vue.set(state.referrers.byId, referrerId, _objectSpread(_objectSpread({}, referrer), {}, {
      id: referrerId,
      timeline
    }));
    if (!_includesInstanceProperty(_context = state.referrers.allIds).call(_context, referrerId)) {
      Vue.set(state.referrers, "allIds", [...state.referrers.allIds, referrerId.toString()]);
    }
  },
  [EDIT_REFERRER]: (state, {
    referrer,
    referrerId
  }) => {
    var _state$referrers$byId2;
    const timeline = (_state$referrers$byId2 = state.referrers.byId[referrerId]) == null ? void 0 : _state$referrers$byId2.timeline;
    Vue.set(state.referrers.byId, referrerId, _objectSpread(_objectSpread({}, referrer), {}, {
      id: referrerId,
      timeline
    }));
  },
  [REMOVE_REFERRER]: (state, {
    referrerId
  }) => {
    var _context2;
    Vue.delete(state.referrers.byId, referrerId);
    Vue.set(state.referrers, "allIds", _filterInstanceProperty(_context2 = state.referrers.allIds).call(_context2, id => id.toString() !== referrerId.toString()));
  },
  [SET_REFERRERS_CUSTOM_FIELDS_DEFINITIONS]: (state, {
    referrersCustomFieldsDefinitions
  }) => {
    Vue.set(state, "referrersCustomFieldsDefinitions", referrersCustomFieldsDefinitions);
  },
  [SET_REFERRER_CUSTOM_FIELD_DEFINITION]: (state, {
    customFieldDefinition
  }) => {
    Vue.set(state.referrersCustomFieldsDefinitions.byId, customFieldDefinition.id, customFieldDefinition);
  },
  [SET_REFERRER_CUSTOM_FIELDS]: async (state, {
    referrerId,
    customFields
  }) => {
    Vue.set(state.referrers.byId[referrerId], "customFields", customFields);
  },
  [REMOVE_REFERRER_CUSTOM_FIELD_DEFINITION]: (state, {
    customFieldDefinitionId
  }) => {
    var _context3;
    Vue.delete(state.referrersCustomFieldsDefinitions.byId, customFieldDefinitionId);
    state.referrersCustomFieldsDefinitions.allIds = _filterInstanceProperty(_context3 = state.referrersCustomFieldsDefinitions.allIds).call(_context3, id => id !== customFieldDefinitionId);
  },
  [SET_REFERRER_CUSTOM_FIELD_ORDER]: (state, {
    customFieldDefinitions
  }) => {
    const byId = state.referrersCustomFieldsDefinitions.byId;
    const updatedCustomFields = _reduceInstanceProperty(customFieldDefinitions).call(customFieldDefinitions, (acc, current) => {
      acc[current.id] = _objectSpread(_objectSpread({}, byId[current.id]), {}, {
        fieldOrder: current.fieldOrder
      });
      return acc;
    }, {});
    Vue.set(state.referrersCustomFieldsDefinitions, "byId", updatedCustomFields);
  },
  [SET_REFERRER_LINKED_APPS]: (state, {
    referrerId,
    clientApplications
  }) => {
    Vue.set(state.referrersLinkedApplications.byId, referrerId, clientApplications);
  },
  [SET_REFERRER_LINKED_PROFILES]: (state, {
    referrerId,
    clientProfiles,
    translationMap
  }) => {
    Vue.set(state.referrersLinkedProfiles.byId, referrerId, clientProfiles);
    Vue.set(state, "linkedProfilesLabelTranslationMap", translationMap);
  },
  [ADD_REFERRER_CUSTOM_FIELD_DEFINITION]: (state, {
    customFieldDefinition
  }) => {
    Vue.set(state.referrersCustomFieldsDefinitions.byId, customFieldDefinition.id, customFieldDefinition);
    Vue.set(state.referrersCustomFieldsDefinitions, "allIds", [...state.referrersCustomFieldsDefinitions.allIds, customFieldDefinition.id]);
  },
  [ADD_REFERRER_TIMELINE_ITEM]: (state, {
    referrerId,
    newItem
  }) => {
    state.referrers.byId[referrerId].timeline.push(newItem);
  },
  [REMOVE_REFERRER_TIMELINE_ITEM]: (state, {
    referrerId,
    timelineItemType,
    timelineItemId
  }) => {
    var _context4;
    Vue.set(state.referrers.byId[referrerId], "timeline", _filterInstanceProperty(_context4 = state.referrers.byId[referrerId].timeline).call(_context4, item => {
      if (item.activityType === timelineItemType && item.id == timelineItemId) return false;
      return true;
    }));
  },
  [SET_REFERRER_TIMELINE_ITEM_DETAILS]: (state, _ref) => {
    var _context5;
    let {
        referrerId,
        timelineItemType,
        timelineItemId
      } = _ref,
      details = _objectWithoutProperties(_ref, _excluded);
    const timelineItemIndex = _findIndexInstanceProperty(_context5 = state.referrers.byId[referrerId].timeline).call(_context5, item => item.activityType === timelineItemType && item.id == timelineItemId);
    Vue.set(state.referrers.byId[referrerId].timeline, timelineItemIndex, _objectSpread(_objectSpread({}, state.referrers.byId[referrerId].timeline[timelineItemIndex]), details));
  },
  [SET_REFERRER_TIMELINE]: (state, {
    referrerId,
    timeline
  }) => {
    Vue.set(state.referrers.byId[referrerId], "timeline", timeline);
  },
  [SET_REFERRER_CHANGELOG]: (state, {
    referrerId,
    changelog
  }) => {
    Vue.set(state.referrers.byId[referrerId], "changelog", changelog);
  },
  [SET_CURRENT_FILTERS]: (state, {
    orderBy,
    orderType,
    searchString,
    type
  }) => {
    state.referrerFilters = mergeWith({}, state.referrerFilters, {
      orderBy,
      orderType,
      searchString
    }, (current, replacement) => replacement != null ? replacement : current);
    state.referrerFilters = mergeWith({}, state.referrerFilters, {
      type
    }, (current, replacement) => replacement === undefined ? current : replacement);
  }
};
export default mutations;